var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.982414,
    height: 22.76,
    viewBox: "0 0 22.982414 22.76",
    id: "svg345",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs349"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title340"
  }, "q") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title340"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-0.10810853,-0.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ski-Inn_Rukavalley28-Desktop-AA-Copy",
    transform: "translate(-124,-1106)",
    fill: "#ff1706",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 137.28,1129.36 v -7.48 c 0,-0.24 0.2,-0.44 0.44,-0.44 H 141 c 0.24,0 0.44,0.2 0.44,0.44 v 7.48 h 2.12 c 0.24,0 0.44,-0.2 0.44,-0.76 v -10.52 h 2.64 c 0.4,0 0.6,-0.44 0.32,-0.72 l -4.8,-4.6 c -0.08,-0.08 -0.16,-0.2 -0.16,-0.32 v -3.12 c 0,-0.24 -0.16,-0.44 -0.4,-0.44 h -1.2 c -0.24,0 -0.44,0.2 -0.44,0.44 v 1.36 l -4.08,-3.96 c -0.16,-0.16 -0.4,-0.16 -0.56,0 l -11.08,10.64 c -0.28,0.28 -0.08,0.72 0.28,0.72 h 2.68 v 10.52 c 0,0.56 0.16,0.76 0.4,0.76 z m -3.8,-3.28 h -3.28 c -0.24,0 -0.44,-0.2 -0.44,-0.44 v -3.76 c 0,-0.24 0.2,-0.44 0.44,-0.44 h 3.28 c 0.24,0 0.4,0.2 0.4,0.44 v 3.76 c 0,0.24 -0.16,0.44 -0.4,0.44 z",
    id: "q"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2dc7f7df40d3eafa7ff79eecf12be022.svg";
export { ForwardRef as ReactComponent };